/**
 * Auto-shrink big currency numbers so long values (VND, KRW, IDR,
 * EGP, etc.) don't overflow their container.
 *
 * Returns a Tailwind text-size class based on the string length of
 * the formatted number. Used by:
 *   - TipPanel (Tip Amount + Total tiles)
 *   - CurrencyPanel (You send + They receive amounts)
 *
 * The buckets here match the empirical widths of the dark tiles in
 * TipPanel; if you tweak one call site's container width, only pass
 * a different `sizes` override rather than editing this helper.
 */
export function fitClass(str, sizes) {
  const len = (str || "").length;
  const s = sizes || {
    lg14: "text-base",
    lg12: "text-lg",
    lg10: "text-xl",
    lg9: "text-2xl",
    dflt: "text-3xl",
  };
  if (len >= 14) return s.lg14;
  if (len >= 12) return s.lg12;
  if (len >= 10) return s.lg10;
  if (len >= 9) return s.lg9;
  if (len >= 8 && s.lg8) return s.lg8;
  return s.dflt;
}
